import { Typography, Box, Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { PieChart } from "@mui/x-charts";
import { EntityDataModel, FieldDataModel } from "./types";
import {
  chartPalette,
  formatFieldName,
  formatStringWithSpace,
} from "../helpers";

const MAX_ITEMS = 7;

const CleaningPieChart = ({
  entityData,
}: {
  entityData: EntityDataModel[];
}) => {
  const sortedData = entityData
    ?.slice()
    .sort((a, b) => a.fieldData.length - b.fieldData.length);

  return (
    <Box sx={{ marginTop: 3 }} data-testid="cleaning-pie-chart">
      <Grid container spacing={2}>
        {sortedData?.map((entity: EntityDataModel) => (
          <Grid
            size={{
              xs: 12,
              sm: 12,
              lg: entity.fieldData.length < 19 ? 6 : 12,
            }}
            key={entity.entityName}
          >
            <Paper
              sx={{
                padding: 2,
                textAlign: "center",
              }}
            >
              <Typography
                variant="h6"
                color="primary"
                gutterBottom
                key={entity.entityName}
              >
                {entity.entityName}
              </Typography>
              <PieChart
                series={[
                  {
                    innerRadius: 68,
                    outerRadius: 100,
                    paddingAngle: 5,
                    cornerRadius: 5,
                    startAngle:
                      entity.fieldData.length < MAX_ITEMS ? -90 : -180,
                    endAngle: entity.fieldData.length < MAX_ITEMS ? 90 : 180,
                    cx: 120,
                    cy: entity.fieldData.length < MAX_ITEMS ? 180 : 150,
                    data: entity.fieldData.map((f: FieldDataModel) => ({
                      label: `${formatStringWithSpace(
                        formatFieldName(f.name),
                      )} (${f.count})`,
                      value: f.count,
                    })),
                  },
                ]}
                colors={chartPalette}
                slotProps={{
                  legend: {
                    labelStyle: {
                      fontSize: 12,
                    },
                  },
                }}
                height={300}
              />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CleaningPieChart;
